import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Sparkle } from './Sparkle';
import { HeartHandshakeIcon, HeadsetIcon, TrendingUpIcon, GlobeIcon } from 'lucide-react';
import { GuideModal } from './GuideModal';
export function BusinessModel() {
  const [guideOpen, setGuideOpen] = useState(false);
  return <section id="ablauf" className="w-full px-4 pb-6 pt-10 sm:px-6 sm:pb-8 sm:pt-12" data-id="element-56" data-mp="s96u5cqjcxox">
      <div className="mx-auto max-w-[1300px]" data-id="element-57" data-mp="1fxpyjh6gsqbq">
        <div className="text-center" data-id="element-58" data-mp="1fvvioha1voei">
          <span className="mb-4 block text-xs font-semibold uppercase tracking-[0.25em] text-white" data-id="element-59" data-mp="1k033w4haum7z">
            Deine Chance aus deiner Superkraft Geld zu machen
          </span>
          <div className="relative inline-block" data-id="element-60" data-mp="1aywpq224hnhw">
            <Sparkle className="animate-sparkle left-4 top-1 h-5 w-5 sm:-left-9 sm:h-7 sm:w-7" data-id="element-61" data-mp="1axbro2glnmfa" />
            <Sparkle className="animate-sparkle-fast right-4 bottom-1 h-4 w-4 sm:-right-8 sm:h-5 sm:w-5" data-id="element-62" data-mp="3qp9bhcld35zk" />
            <h2 className="font-display text-gold-3d mx-auto max-w-4xl text-2xl font-extrabold uppercase leading-[1.15] sm:text-3xl lg:text-4xl" data-id="element-63" data-mp="3vqozndiu5sm6">
              Das Geschäftsmodell einfach erklärt
            </h2>
          </div>
          <p className="mx-auto mt-6 max-w-3xl text-base leading-relaxed text-white" data-id="element-64" data-mp="22j8o5u2rx6ev">
            <span className="block" data-id="element-65" data-mp="2gekii0d0ouv9">
              Wir zeigen dir, wie du als Premium-Closerin für Unternehmen, Coaches und Dienstleister
              hochpreisige Angebote verkaufst und für erfolgreiche Abschlüsse attraktive Provisionen
              erhältst.
            </span>
            <span className="mt-3 block" data-id="element-66" data-mp="2lf8gj5znybyz">
              Du lernst die entscheidenden Sales-Skills, wie du passende High-Ticket-Projekte findest
              und erfolgreich in Remote Sales startest. Zusätzlich profitierst du von unserem
              internationalen Netzwerk und spannenden Kontakten.
            </span>
          </p>
          <button type="button" onClick={() => setGuideOpen(true)} className="btn-gold-shiny mt-4 inline-flex items-center justify-center gap-2 rounded-full px-6 py-2.5 text-sm font-semibold" data-id="element-67" data-mp="34682dybv35o1">
            Guide kostenlos sichern
          </button>
        </div>

        <div className="mt-6 grid gap-5 md:grid-cols-3 md:gap-4" data-id="element-68" data-mp="3l7vqkq6mc52i">
          {/* Card 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.45,
          delay: 0.1
        }} className="flex flex-col rounded-3xl bg-white p-6 shadow-xl md:p-5 lg:p-8" data-id="element-69" data-mp="3pyc40aafvqov">
            <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-2xl bg-hot-50 text-hot-500 md:mb-4 md:h-10 md:w-10" data-id="element-70" data-mp="7sfvnykq37b2">
              <HeartHandshakeIcon className="h-6 w-6 md:h-5 md:w-5" data-id="element-71" data-mp="cr0xg2fmhz1m" />
            </div>
            <h3 className="font-heading text-xl font-bold leading-tight text-neutral-900 md:text-base lg:text-xl" data-id="element-72" data-mp="29ldr825vwdzp">
              Gespräche auf Augenhöhe
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-neutral-600" data-id="element-73" data-mp="2705zcpf5o6k0">
              Du führst Gespräche mit Menschen, die bereits echtes Interesse an einem Angebot haben.
              Dabei geht es nicht darum, jemanden zu überreden, sondern zuzuhören, die richtigen
              Fragen zu stellen und gemeinsam herauszufinden, ob das Angebot wirklich zu der Person
              passt. Authentisch, auf Augenhöhe und ohne Verkaufsdruck.
            </p>
          </motion.div>

          {/* Card 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.45,
          delay: 0.2
        }} className="flex flex-col rounded-3xl bg-white p-6 shadow-xl md:p-5 lg:p-8" data-id="element-74" data-mp="2kz5ody6kyngp">
            <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-2xl bg-hot-50 text-hot-500 md:mb-4 md:h-10 md:w-10" data-id="element-75" data-mp="14mqpmvok1f0a">
              <HeadsetIcon className="h-6 w-6 md:h-5 md:w-5" data-id="element-76" data-mp="2og9zj7gzbl6g" />
            </div>
            <h3 className="font-heading text-xl font-bold leading-tight text-neutral-900 md:text-base lg:text-xl" data-id="element-77" data-mp="2oe6zrvq0ydoj">
              Alles, was du tun musst: Gute Gespräche führen
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-neutral-600" data-id="element-78" data-mp="2ejx70cx67dda">
              Du brauchst weder eine eigene Reichweite noch ein eigenes Produkt und musst dich auch
              nicht um Werbung kümmern. Die Unternehmen sorgen für die Interessenten und
              vereinbarten Termine – diese landen automatisch in deinem Kalender. Dein einziger
              Fokus liegt nur auf dem Führen der Gespräche.
            </p>
          </motion.div>

          {/* Card 3 (Wide, below) */}
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.45,
          delay: 0.3
        }} className="order-last flex flex-col rounded-3xl bg-gradient-to-b from-white to-hot-50/50 p-6 shadow-xl md:col-span-3 lg:flex-row lg:items-center lg:gap-10 lg:p-8" data-id="element-79" data-mp="325tz64f9k2bj">
            <div className="lg:flex-1" data-id="element-80" data-mp="3xwfjrbnbr2c">
              <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-2xl bg-hot-50 text-hot-500" data-id="element-81" data-mp="hvup8jf0uzbi">
                <TrendingUpIcon className="h-6 w-6" data-id="element-82" data-mp="dv12htdbfqk7" />
              </div>
              <h3 className="font-heading text-xl font-bold leading-tight text-neutral-900" data-id="element-83" data-mp="3m99mwe5opb1a">
                Attraktives Einkommen bei flexibler Zeiteinteilung
              </h3>
              <p className="mt-3 max-w-2xl text-sm leading-relaxed text-neutral-600" data-id="element-84" data-mp="3v234wjcimoiu">
                Im High-Ticket-Sales können bereits einzelne erfolgreiche Abschlüsse mehrere Hundert
                Euro einbringen. Je nach Unternehmen und Angebot sind 500–1.500 € pro Abschluss
                möglich. So kannst du dir ein Top-Einkommen aufbauen, ohne 40+ Stunden pro Woche in
                einem klassischen 9-to-5-Job festzuhängen.
              </p>
            </div>

            {/* Decorative Chart Element */}
            <div className="mt-8 flex flex-1 items-center justify-center pb-2 pt-6 lg:mt-0 lg:pb-0 lg:pt-8" data-id="element-85" data-mp="16i5j5j8d3fjq">
              <div className="relative aspect-[2/1] w-full max-w-[180px] lg:max-w-[320px]" data-id="element-86" data-mp="1b9444w4ap1tb">
                <svg viewBox="0 0 200 100" className="h-full w-full overflow-visible" data-id="element-87" data-mp="1g8qgl3caue12">
                  <path d="M0,80 Q20,80 40,50 T80,60 T120,20 T160,40 T200,10" fill="none" stroke="#fe4da2" strokeWidth="4" strokeLinecap="round" data-id="element-88" data-mp="ikykkcoz9iv2" />
                  <circle cx="0" cy="80" r="4" fill="#fe4da2" data-id="element-89" data-mp="skz707i58f3h" />
                  <circle cx="40" cy="50" r="4" fill="#fe4da2" data-id="element-90" data-mp="xiqvssnhrl3g" />
                  <circle cx="80" cy="60" r="4" fill="#fe4da2" data-id="element-91" data-mp="23ybauidwkxpn" />
                  <circle cx="120" cy="20" r="4" fill="#fe4da2" data-id="element-92" data-mp="2405nzaixnlj6" />
                  <circle cx="160" cy="40" r="4" fill="#fe4da2" data-id="element-93" data-mp="28w30f5r2s7qo" />
                  <circle cx="200" cy="10" r="4" fill="#fe4da2" data-id="element-94" data-mp="3tex4mnxip2am" />
                  
                </svg>
                
                {/* Labels */}
                <div className="absolute left-[0%] top-[62%] -translate-x-1/4 -translate-y-1/2 rounded-full bg-white px-2 py-0.5 text-[10px] font-bold text-hot-500 shadow-sm border border-hot-100" data-id="element-95" data-mp="3ogvmq6btv90q">
                  3.000€
                </div>
                <div className="absolute left-[20%] top-[35%] -translate-x-1/2 -translate-y-1/2 rounded-full bg-white px-2 py-0.5 text-[10px] font-bold text-hot-500 shadow-sm border border-hot-100" data-id="element-96" data-mp="39qxw7jqfe78d">
                  5.500€
                </div>
                <div className="absolute left-[60%] top-[5%] -translate-x-1/2 -translate-y-1/2 rounded-full bg-white px-2 py-0.5 text-[10px] font-bold text-hot-500 shadow-sm border border-hot-100" data-id="element-97" data-mp="30r19voridkgh">
                  8.700€
                </div>
                <div className="absolute left-[100%] top-[10%] -translate-x-[35%] -translate-y-[105%] rounded-full bg-white px-2 py-0.5 text-[10px] font-bold text-hot-500 shadow-sm border border-hot-100" data-id="element-98" data-mp="u0b9xroimz6r">
                  10k€
                </div>
              </div>
            </div>
          </motion.div>

          {/* Card 4 (Wide) */}
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.45,
          delay: 0.4
        }} className="flex flex-col gap-6 rounded-3xl bg-white p-6 shadow-xl md:gap-4 md:p-5 lg:p-8" data-id="element-99" data-mp="3p9il5sfqhpjv">
            <div className="flex-1" data-id="element-100" data-mp="3l6c73ymdqu2u">
              <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-2xl bg-hot-50 text-hot-500 md:mb-4 md:h-10 md:w-10" data-id="element-101" data-mp="36c7n2b5u9260">
                <GlobeIcon className="h-6 w-6 md:h-5 md:w-5" data-id="element-102" data-mp="3barbqjbtgs22" />
              </div>
              <h3 className="font-heading text-xl font-bold leading-tight text-neutral-900 md:text-base lg:text-xl" data-id="element-103" data-mp="14lcnd88igiu0">
                Arbeite von überall auf der Welt
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-neutral-600" data-id="element-104" data-mp="2u288p5stj2ms">
                Alles, was du brauchst, sind dein Smartphone und eine stabile Internetverbindung. Ob
                von zu Hause, aus deinem Lieblingscafé oder unterwegs auf Reisen – du entscheidest,
                wo dein Arbeitsplatz heute ist. Arbeite ortsunabhängig und gestalte dein Leben frei
                und selbstbestimmt.
              </p>
            </div>
            
            {/* Decorative Globe Element */}
            <div className="relative mx-auto flex h-32 w-32 shrink-0 items-center justify-center rounded-full border-2 border-dashed border-hot-200 md:h-24 md:w-24 lg:h-36 lg:w-36" data-id="element-105" data-mp="38p1hds7u1a60">
              <div className="absolute h-full w-full animate-[spin_20s_linear_infinite] rounded-full border border-hot-100" data-id="element-106" data-mp="3hqhp1s79iy6j" />
              <div className="absolute h-full w-full animate-[spin_15s_linear_infinite_reverse] rounded-full border border-hot-100" style={{
              transform: 'rotateX(60deg)'
            }} data-id="element-107" data-mp="1scmfiguiflld" />
              <div className="absolute h-full w-full animate-[spin_25s_linear_infinite] rounded-full border border-hot-100" style={{
              transform: 'rotateY(60deg)'
            }} data-id="element-108" data-mp="7ndnox5dutum" />
              
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-white px-2 py-1 text-[10px] font-semibold text-hot-500 shadow-md" data-id="element-109" data-mp="3tu243ys8jc34">Dubai</div>
              <div className="absolute top-1/2 -left-6 -translate-y-1/2 whitespace-nowrap rounded-full bg-white px-2 py-1 text-[10px] font-semibold text-hot-500 shadow-md" data-id="element-110" data-mp="qdlnp6dsd46l">Zypern</div>
              <div className="absolute top-1/2 -right-6 -translate-y-1/2 whitespace-nowrap rounded-full bg-white px-2 py-1 text-[10px] font-semibold text-hot-500 shadow-md" data-id="element-111" data-mp="lglg2r1aftdd">Kapstadt</div>
              <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-white px-2 py-1 text-[10px] font-semibold text-hot-500 shadow-md" data-id="element-112" data-mp="clyek5yqw16e">Bali</div>
            </div>
          </motion.div>
        </div>
        
        <div className="mt-8 text-center" data-id="element-113" data-mp="2n0nw7uye4b5u">
          <a href="#guide" className="btn-gold-shiny inline-flex items-center justify-center gap-2 rounded-full px-6 py-2.5 text-sm font-semibold" data-id="element-114" data-mp="2n1pa076sjbr9">
            Kennenlerncall buchen
          </a>
        </div>
      </div>

      <GuideModal open={guideOpen} onClose={() => setGuideOpen(false)} data-id="element-115" data-mp="310f5xjhvj5e1" />
    </section>;
}